
import { connectAppStore } from "../../../../Store/AppStore";
import PageDependencies from "../../../../Feature/PageDependencies";

const ExternalScreenDetail = (props) => {
    const { 
        layoutManager,
        guid,
        useReducerSmart,
        useParams,
        useLocation,
        BaseForm,
        BindedInput,
        BindedSelect,
        getAppStore,
        pageProfile,
        loaModelFromApi,
        FormValidate,
        dataExtension,
        Fragment, useEffect, useState,
        useEffectWithPrevious
    } = PageDependencies();
    let debug = layoutManager.Layout_GetDebugModel(props);
    const emptyGuid = guid.emptyGuid();
    const currentUrl = useLocation().pathname;
    const defaultParams = pageProfile.getDefaultParams(useParams());
    const [init, setInit] = useState(false);
    const [reloadForm, setReloadForm] = useState("");
    const { designVariationVersionName, developmentId, projectId, designVariationId, zoneId, parentId, redirectUrlHex, elementId } = defaultParams;
    const defaultViewModel = {
        ...defaultParams,
        selectedItemIds: [elementId]
    };
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart(defaultViewModel);
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    const [appStoreState, appStoreDispatch] = getAppStore(props); 
    const getUrl = "api/Element/Accessor/GetVerticalShadingElement";
    const postUrl = "api/Element/Accessor/UpdateVerticalShadingElement";
    const validateMethods = {
        // name:(value)=>{return FormValidate.validateTextRequired(value, "External screen name");},
        verticalShadingId:(value)=>{ return value === emptyGuid ? "Must select a vertical shading." : "";},
        // length: (value) => { return FormValidate.validateNumberGreaterThan0(value, "Length");},
        // height: (value) => { return FormValidate.validateNumberGreaterThan0(value, "Height");},
    };
    const formValidate = new FormValidate(useState(validateMethods), useState(), useState(), useState(), false);

    useEffect(()=>{
        layoutManager.Layout_Headter_Footer_SideBar(props);
        loaModelFromApi.loadDefault(true, getUrl, viewModel, dispatchViewModel, setLoading, "Loading data", appStoreDispatch, undefined, setInit);
    },[]);

    useEffect(()=>{  
        if(init){
          dispatchViewModel({...viewModel, elementId: elementId, id: elementId, selectedItemIds: [elementId]}, ()=>{
            setReloadForm(guid.newGuid());
          });
        } 
    },[elementId]);

    const updateSimpleShading = () =>{
        try{
            let shading = dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId);
                        if(shading !== null){ 
                            if(shading.shadingInputMethodTypeId == 2){
                                let width = shading.width;
                                let height = shading.height;
                                if(shading.shadingInputMethodTypeId == 2){
                                    const positionWallObstruction = shading.verticalShadingPositionOfWallTypeObstruction * 1000;                    
                                    const storyNumberOfNeighbourBuilding = shading.storyNumberOfNeighbourBuilding * 1;
                                    const wallWidth = viewModel.externalWallWidth;
                                height = ((3 + (storyNumberOfNeighbourBuilding - 1) * 2.7) * 1000);                                       
                                if(shading.verticalShadingPositionOfWallTypeId == 1){
                                    width = positionWallObstruction + wallWidth;                              
                                }
                                if( shading.verticalShadingPositionOfWallTypeId == 2){                                     
                                    width = positionWallObstruction + wallWidth;                                                
                                }
                                if( shading.verticalShadingPositionOfWallTypeId == 3){
                                    width = positionWallObstruction + wallWidth;                          
                                }
                                height = parseInt(height);
                                width = parseInt(width);
                                const newModel = {...viewModel, height: height, width: width};
                                dispatchViewModel(newModel);
                            }
                        }
                    }
        }catch{}
    }

    useEffectWithPrevious((oldValue)=>{
        if(oldValue === undefined || oldValue[0] === undefined) {
            updateSimpleShading();
            return;
        }

        const shading = dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId);
        if(shading !== null){     
            let height = shading.height;
            let width = shading.width;
            let distance = shading.distance;
            let horizontalOffset = 0;
            let verticalOffset = shading.verticalOffset;
            if(shading.shadingInputMethodTypeId == 2){
                const positionWallObstruction = shading.verticalShadingPositionOfWallTypeObstruction * 1000;
                const positionWallOffset = shading.verticalShadingPositionOfWallTypeOffset * 1000;
                distance = shading.verticalShadingDistanceCategoryTypeDistance * 1000;
                const storyNumberOfNeighbourBuilding = shading.storyNumberOfNeighbourBuilding * 1;
                const wallWidth = viewModel.externalWallWidth;
                height = ((3 + (storyNumberOfNeighbourBuilding - 1) * 2.7) * 1000);
                if(shading.verticalShadingVerticalCategoryTypeId == 2){
                    verticalOffset = 1500;
                }
                if(shading.verticalShadingPositionOfWallTypeId == 1){
                    width = positionWallObstruction + wallWidth;
                    horizontalOffset = positionWallOffset + wallWidth;
                }
                if( shading.verticalShadingPositionOfWallTypeId == 2){
                    width = positionWallObstruction + wallWidth;
                    horizontalOffset = positionWallOffset; 
                }
                if( shading.verticalShadingPositionOfWallTypeId == 3){
                    width = positionWallObstruction + wallWidth;
                    horizontalOffset = positionWallOffset;
                }                               
            }
            height = parseInt(height);
            width = parseInt(width);
            distance = parseInt(distance);
            horizontalOffset = parseInt(horizontalOffset);
            verticalOffset = parseInt(verticalOffset);
            const newModel = {...viewModel, height: height, width: width, distance: distance, horizontalOffset: horizontalOffset, verticalOffset: verticalOffset};
            dispatchViewModel(newModel);
        }
    },[viewModel.verticalShadingId]);

    const generateStayUrl = (submitResponse)=>{
        let redirectUrl = currentUrl;
        if(elementId === emptyGuid){
            //ElementAssessor/Detail/ExternalScreen/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex
            redirectUrl =  "/ElementAssessor/Detail/ExternalScreen/" + designVariationVersionName + "/" + developmentId +"/"+projectId+"/"+designVariationId+"/"+zoneId+"/"+submitResponse.elementId +"/"+parentId+"/"+redirectUrlHex;
        }
        return redirectUrl;
    }
    return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            <BaseForm
                id="DesignVariationFrom"
                icon="pe-7s-safe"
                loading={loading}
                init={init}
                setLoading={setLoading}
                submitButton={{ postUrl: postUrl, redirectUrl: viewModel.redirectUrl, text: "Save and close"}}
                submitButtonAndStay={{ text:"Save", postUrl: postUrl, redirectMethod: (submitResponse)=>{return generateStayUrl(submitResponse)}}}
                cancelButton={{ redirectUrl: viewModel.redirectUrl }}
                data={viewModel}
                validate ={formValidate}
                title = {"External Screen"} 
                subTitle={pageProfile.getPageSubTitle(appStoreState)}
            >
                <div className="form-row row">
                    <div className="col-6">
                        <div className="position-relative form-group">
                        <label htmlFor="ShadingName">Name *</label>
                            <BindedInput validate={formValidate} className="form-control valid" id="ShadingName" name="ShadingName" type="text" binding={[viewModel, "name", bindingViewModel]}></BindedInput>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="position-relative form-group">
                            <label htmlFor="VerticalElementShadingVerticalShadingId">Available screens *</label>
                            <BindedSelect
                                className="form-control"
                                id="VerticalElementShadingVerticalShadingId"
                                name="VerticalElementShadingVerticalShadingId"
                                options="verticalShadings"
                                binding={[viewModel, "verticalShadingId", bindingViewModel]}
                            ></BindedSelect>
                        </div>
                    </div>
                </div>
                {viewModel.simulationType === "New Home" && <>
                    <div className="form-row row">
                        <div className="col-4">
                            <div className="position-relative form-group">
                                <label htmlFor="VerticalElementShadingHeight">Height (mm) *</label>           
                                <BindedInput disabled className="form-control valid" id="VerticalElementShadingHeight" name="VerticalElementShadingHeight" validate={formValidate} type="number" binding={[viewModel, "height", bindingViewModel]}></BindedInput>                
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="position-relative form-group">
                                <label htmlFor="VerticalElementShadingWidth">Width (mm) *</label>           
                                <BindedInput disabled className="form-control" id="VerticalElementShadingWidth" name="VerticalElementShadingWidth" validate={formValidate} type="number" binding={[viewModel, "width", bindingViewModel]}></BindedInput>                
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="position-relative form-group">
                                <label htmlFor="VerticalElementShadingDistance">Distance (mm) *</label>           
                                <BindedInput className="form-control valid" id="VerticalElementShadingDistance" name="VerticalElementShadingDistance" validate={formValidate} type="number" binding={[viewModel, "distance", bindingViewModel]}></BindedInput>       
                            </div>
                        </div>
                    </div>
                    <div className="form-row row">
                        <div className="col-4">
                            <div className="position-relative form-group">
                            <label htmlFor="VerticalElementShadingHorizontalOffset">Horizontal offset (mm) *</label>           
                                <BindedInput className="form-control valid" id="VerticalElementShadingHorizontalOffset" name="VerticalElementShadingHorizontalOffset" validate={formValidate} type="number" binding={[viewModel, "horizontalOffset", bindingViewModel]}></BindedInput>  
                            </div>
                        </div>
                        <div className="col-4">
                        <div className="position-relative form-group">
                            <label htmlFor="VerticalElementShadingVerticalOffset">Vertical offset (mm) *</label>           
                                <BindedInput className="form-control valid" id="VerticalElementShadingVerticalOffset" name="VerticalElementShadingVerticalOffset" validate={formValidate} type="number" binding={[viewModel, "verticalOffset", bindingViewModel]}></BindedInput>  
                            </div>
                        </div>
                    </div>
                    <div className="form-row row">
                        <div className="col-12">
                            <label>Blocking factor (opaque = 100%)</label>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage0">Jan</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage0}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage1">Feb</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage1}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage2">Mar</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage2}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage3">Apr</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage3}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage4">May</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage4}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage5">Jun</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage5}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage6">Jul</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage6}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage7">Aug</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage7}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage8">Sep</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage8}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage9">Oct</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage9}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage10">Nov</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage10}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage11">Dec</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage11}</label>
                            </div>
                        </div>
                    </div>
                </>}
                {viewModel.simulationType !== "New Home" && <>
                    <div className="form-row row">
                        <div className="col-4">
                            <div className="position-relative form-group">
                                <label htmlFor="VerticalElementShadingHeight">Shade Feature Height (mm) *</label>           
                                <BindedInput disabled className="form-control valid" id="VerticalElementShadingHeight" name="VerticalElementShadingHeight" validate={formValidate} type="number" binding={[viewModel, "height", bindingViewModel]}></BindedInput>                
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="position-relative form-group">
                                <label htmlFor="VerticalElementShadingWidth">Shade Feature Width (mm) *</label>           
                                <BindedInput disabled className="form-control" id="VerticalElementShadingWidth" name="VerticalElementShadingWidth" validate={formValidate} type="number" binding={[viewModel, "width", bindingViewModel]}></BindedInput>                
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="position-relative form-group">
                                <label htmlFor="VerticalElementShadingDistance">Distance to Shade Feature (mm) *</label>           
                                <BindedInput disabled={dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId) != null && dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId).shadingInputMethodTypeId == 2} className="form-control valid" id="VerticalElementShadingDistance" name="VerticalElementShadingDistance" validate={formValidate} type="number" binding={[viewModel, "distance", bindingViewModel]}></BindedInput>       
                            </div>
                        </div>
                    </div>
                    <div className="form-row row">
                        <div className="col-4">
                            <div className="position-relative form-group">
                            <label htmlFor="VerticalElementShadingVerticalOffset">Shade Feature Vertical offset (mm) *</label>           
                                <BindedInput disabled={dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId) != null && dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId).shadingInputMethodTypeId == 2} className="form-control valid" id="VerticalElementShadingVerticalOffset" name="VerticalElementShadingVerticalOffset" validate={formValidate} type="number" binding={[viewModel, "verticalOffset", bindingViewModel]}></BindedInput>  
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="position-relative form-group">
                            <label htmlFor="VerticalElementShadingHorizontalOffset">Shade Feature Horizontal offset (mm) *</label>           
                                <BindedInput disabled={dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId) != null && dataExtension.getObjectByPropertyValue(viewModel.verticalShadings, "value", viewModel.verticalShadingId).shadingInputMethodTypeId == 2} className="form-control valid" id="VerticalElementShadingHorizontalOffset" name="VerticalElementShadingHorizontalOffset" validate={formValidate} type="number" binding={[viewModel, "horizontalOffset", bindingViewModel]}></BindedInput>  
                            </div>
                        </div>
                    </div>
                    <div className="form-row row" hidden>
                        <div className="col-12">
                            <label>Blocking factor (opaque = 100%)</label>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage0">Jan</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage0}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage1">Feb</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage1}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage2">Mar</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage2}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage3">Apr</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage3}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage4">May</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage4}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage5">Jun</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage5}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage6">Jul</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage6}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage7">Aug</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage7}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage8">Sep</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage8}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage9">Oct</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage9}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage10">Nov</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage10}</label>
                            </div>
                        </div>
                        <div className="col-1">
                            <div className="position-relative form-group">
                                <label htmlFor="ShadingBlockingFactorPercentage11">Dec</label>           
                                <label className="form-control" style={{ border: "none", backgroundColor: "white" }}> {viewModel.blockingFactorPercentage11}</label>
                            </div>
                        </div>
                    </div>
                </>}
            </BaseForm>
        </Fragment>
    );
}
export default connectAppStore(ExternalScreenDetail);